type PendingTextEditFlusher = () => void;

const pendingTextEditFlushers = new Set<PendingTextEditFlusher>();

export function registerPendingTextEdit(flusher: PendingTextEditFlusher): () => void {
  pendingTextEditFlushers.add(flusher);

  return () => {
    pendingTextEditFlushers.delete(flusher);
  };
}

export function flushPendingTextEdits(): void {
  const flushers = Array.from(pendingTextEditFlushers);

  flushers.forEach((flusher) => {
    flusher();
  });
}

export function clearPendingTextEditsForTests(): void {
  pendingTextEditFlushers.clear();
}
